module.exports = __webpack_public_path__ + "img/sh_app@2x.4c8112c1.png";